import AdditionalFeeManagementTableRow from './AdditionalFeeManagementTableRow.vue';

export default AdditionalFeeManagementTableRow;
